import { render, staticRenderFns } from "./newOaWorkflowUndo.vue?vue&type=template&id=ff95550c&scoped=true"
import script from "./newOaWorkflowUndo.vue?vue&type=script&lang=js"
export * from "./newOaWorkflowUndo.vue?vue&type=script&lang=js"
import style0 from "./newOaWorkflowUndo.vue?vue&type=style&index=0&id=ff95550c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff95550c",
  null
  
)

export default component.exports